/* eslint-disable prettier/prettier */
/* eslint-disable react/react-in-jsx-scope */
import i18n from 'i18next';
    import { initReactI18next } from 'react-i18next';
    import HttpApi from 'i18next-http-backend';
    import LanguageDetector from 'i18next-browser-languagedetector';
    import { appConfig } from './config/app-config';
    const language = window.sessionStorage.getItem('language') || 'en';

    i18n
      .use(HttpApi)
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        supportedLngs: ['en', 'es-MX','es-US'],
        fallbackLng: 'en',
        lng: language,
        detection: {
          order: ['path', 'cookie', 'htmlTag', 'localStorage', 'sessionStorage', 'navigator', 'querystring', 'subdomain'],
          caches: ['cookie'],
        },
        backend: {
          loadPath: `${appConfig.microUrl}/payment1/translation/{{lng}}/{{ns}}.json`,
        },
        ns: [
          'Autopay',
          'BackRent',
          'Offers',
          'Payment',
          'Reverse',
          'SearchCustomer',
          'translation',
        ],
        defaultNS: 'translation',
        react: {
          useSuspense: false,
        },
      });

    export default i18n;